import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as actions from "../../actions";
import * as Template from "../../templates";
import { useNavigate, useParams } from "react-router-dom";

export default (props) => {
  const moduleName = "attribute_items";
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const params = useParams()

  const navigate = useNavigate()

  const [id, setId] = useState();


  const [name, setName] = useState(``);
  const [state, setState] = useState(``);
  const [categoryId, setCategoryId] = useState(``);
  const [categories, setCategories] = useState(``);

  const [submitted, setSubmitted] = useState(false);

  const onChange = (value) => setCategoryId(value);

  const handleChangeState = (value) => setState(value);

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };


  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.attribute_items_store != undefined && appReducer.attribute_items_store.error == false) ||
        (appReducer.attribute_items_update != undefined && appReducer.attribute_items_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.attribute_items_store,
    appReducer.attribute_items_update
  ])

  useEffect(() => {
    if (appReducer.attribute_items_edit != undefined && id != undefined) {
      let row = appReducer.attribute_items_edit.data;
      setName(row.name);
      setState({
        value: row.state,
        label: row.state == `active` ? `فعال` : `غیرفعال`,
      });
      setCategoryId({
        value: row.attribute.id,
        label: row.attribute.name,
      });
    }
  }, [appReducer.attribute_items_edit]);

  useEffect(() => {
    if (appReducer.attributes_option_list != undefined) {
      setCategories(appReducer.attributes_option_list.data);
    }
  }, [appReducer.attributes_option_list]);

  useEffect(() => {
    dispatch(actions.list(`attributes/option`));
  }, []);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  return <Template.Form>
    <Template.Input required value={name} label="نام" name="name" type="text" />
    <Template.SingleSelect
      withLabel
      required
      placeholder="گروه"
      name="attribute_id"
      value={categoryId}
      onChange={onChange}
      options={categories}
    />
    <Template.SingleSelect
      withLabel
      required
      placeholder="وضعیت"
      onChange={handleChangeState}
      name="state"
      value={state}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />
    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>;
};
